import React from 'react';
import { ratingTypes } from '../../../utils/constants';

import { getRatingDetails, setRatingChoice } from '../../../utils';

export const initialState = {
    rows: [],
    isLoad: true,
    count: 0,
};

export const SORT_ORDER = {
    ASC: 'asc',
    DESC: 'desc',
};

export const defaultTableFilters = {
    order: SORT_ORDER.DESC,
    page: 1,
    limit: 10,
};

export const defaultConferenceColumn = {
    title: 'Conference',
    maxWidth: 20,
    sortable: false,
};

export const defaultDivisionColumn = {
    title: 'Division',
    maxWidth: 20,
    sortable: false,
};

export const defaultP6Column = {
    title: 'P6',
    maxWidth: 7,
};

export const defaultGenderColumn = {
    title: 'Gender',
    maxWidth: 7,
    sortable: false,
};

export const defaultRecordColumn = {
    title: 'W/L',
    maxWidth: 7,
    sortable: false,
};

export const defaultRankingColumn = {
    title: '#',
    maxWidth: 10,
};

export const defaultUtrSinglesColumn = {
    maxWidth: 14,
    key: 'singlesUtr',
};

export const defaultUtrDoublesColumn = {
    maxWidth: 12,
    key: 'doublesUtr',
};

export const defaultUtrSinglesMaskedColumn = {
    ...defaultUtrSinglesColumn,
    key: 'singlesUtrMasked',
};
export const defaultUtrDoublesMaskedColumn = {
    ...defaultUtrDoublesColumn,
    key: 'doublesUtrMasked',
};

export const singlesUtrTitle = (style) => (
    <div className={`${style.TextWithIcon}`}>
        <span>{ratingTypes.tennis}</span>
        <span className={`${style.icon}`}>
            <img src={'/img/v2/icons/utr-user.svg'} className="img-fluid" alt="" />
        </span>
    </div>
        );

export const doublesUtrTitle = (style) => (
    <div className={`${style.TextWithIcon}`}>
        <span>{ratingTypes.tennis}</span>
        <span className={`${style.icon}`}>
            <img src={'/img/v2/icons/utr-users.svg'} className="img-fluid" alt="" />
        </span>
    </div>
        );

export const singlesUtrRating = (val, item, style) => {
            const singlesRating = getUtrRating(item.source, 'singles');
            return (
                <div className={`${singlesRating.verified ? style.ratings : ''}`}>
                    <span>{singlesRating?.value ? singlesRating.value : ''}</span>
                    {singlesRating.verified && (
                        <span className="verified16" title="Verified" />
                    )}
                </div>
            );
        };

export const singlesUtrMaskedRating = (val, item, style) => {
            const singlesRating = getUtrRating(item.source, 'singles');
            return (
                <div className={`${singlesRating.verified ? style.ratings : ''}`}>
                    <span>{singlesRating?.value ? `${parseInt(singlesRating.value)}.xx` : ''}</span>
                    {singlesRating.verified && (
                        <span className="verified16" title="Verified" />
                    )}
                </div>
            );
        };

export const doublesUtrRating = (val, item, style) => {
            const doublesRating = getUtrRating(item.source, 'doubles');
            return (
                <div className={`${doublesRating.verified ? style.ratings : ''}`}>
                    <span>{doublesRating?.value ? doublesRating.value : ''}</span>
                    {doublesRating.verified && (
                        <span className="verified16" title="Verified" />
                    )}
                </div>
            );
        };

export const doublesUtrMaskedRating = (val, item, style) => {
            const doublesRating = getUtrRating(item.source, 'doubles');
            return (
                <div className={`${doublesRating.verified ? style.ratings : ''}`}>
                    <span>{doublesRating?.value ? `${parseInt(doublesRating.value)}.xx` : ''}</span>
                    {doublesRating.verified && (
                        <span className="verified16" title="Verified" />
                    )}
                </div>
            );
        };

const getUtrRating = (player, rating) => {
    return getRatingDetails(
                setRatingChoice({
                    player,
                    ratingType: rating,
                    utrType: 'sanctioned',
                }),
                false,
                false,
                false,
                false,
            );
};
